/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Heading_HintInputs */

const en_reading_class_heading_hint = /** @type {(inputs: Reading_Class_Heading_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapter and section titles`)
};

const es_reading_class_heading_hint = /** @type {(inputs: Reading_Class_Heading_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos de capítulos y secciones`)
};

/**
* | output |
* | --- |
* | "Chapter and section titles" |
*
* @param {Reading_Class_Heading_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_heading_hint = /** @type {((inputs?: Reading_Class_Heading_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Heading_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_heading_hint(inputs)
	return en_reading_class_heading_hint(inputs)
});